import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../../../core/services/app-config.service';
import { Regulation } from '../../models/regulation.model';

@Injectable({
  providedIn: 'root',
})
export class RegulationsApiService {
  constructor(
    private appConfig: AppConfig,
    private http: HttpClient) {
  }


  public getRegulations(): Observable<Regulation[]> {
    return this.http.get<Regulation[]>(`${this.appConfig.config.publicUrl}/regulations`, {
      observe: 'body',
    });
  }

  public getDefermentRegulations(): Observable<Regulation[]> {
    return this.http.get<Regulation[]>(`${this.appConfig.config.apiUrl}/payments/regulations/deferment`, {
      observe: 'body',
    });
  }
  public getTopUpRegulations(): Observable<Regulation[]> {
    return this.http.get<Regulation[]>(`${this.appConfig.config.apiUrl}/top-up/regulations`, {
      observe: 'body',
    });
  }
}
